import React, { useContext, useEffect } from "react";
import { Checkbox, FormControlLabel, List, ListItem, Stack, Typography } from "@mui/material";
import { QuestionsContext, ReviewContext } from "../../../provider/MyContexts";
import { reviewTypeValues } from "./config";

export default function DetailSetting() {
  const { questions } = useContext(QuestionsContext);

  const {
    reviewTypes,
    handleChangeReviewType,
    handleChangeReviewTypeAll,
    reviewTargets,
    handleChangeReviewTarget,
    handleChangeReviewTargetAll,
  } = useContext(ReviewContext);

  useEffect(() => {
    if (reviewTargets.length !== questions.length || reviewTargets.length < questions.length) {
      handleChangeReviewTargetAll(questions);
    }
  }, [questions]);

  return (
    // todo: 折り畳みできるようにする
    <Stack direction={"row"} spacing={1} paddingX={1} flex={1} width={"100%"}>
      <Stack flex={1}>
        <Typography variant="label_M">チェック観点</Typography>

        <FormControlLabel
          label={<Typography variant="label_M">{"全て"}</Typography>}
          control={
            <Checkbox
              size="small"
              checked={reviewTypes.length === reviewTypeValues.length}
              onChange={() => handleChangeReviewTypeAll()}
            />
          }
        />
        {reviewTypeValues.map((type, index) => (
          <FormControlLabel
            key={index}
            label={<Typography variant="label_M">{type.label}</Typography>}
            sx={{
              marginLeft: 2,
            }}
            control={
              <Checkbox
                size="small"
                id={type.id}
                checked={reviewTypes.find((i) => i === type.id) ? true : false}
                onChange={(e) => {
                  handleChangeReviewType(e.target.id);
                }}
              />
            }
          />
        ))}
      </Stack>
      <Stack flex={1}>
        <Typography variant="label_M">対象設問</Typography>

        <FormControlLabel
          label={<Typography variant="label_M">{"全て"}</Typography>}
          control={
            <Checkbox
              checked={reviewTargets.length === questions.length}
              onChange={() => handleChangeReviewTargetAll(questions)}
            />
          }
        />
        {questions.length === 0 ? (
          <Stack flex={1} justifyContent={"center"} alignItems={"center"}>
            <Typography variant="label_M">ローディング...</Typography>
          </Stack>
        ) : (
          <List dense>
            {questions.map((q, index) => (
              <ListItem
                key={index}
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                }}
                disablePadding
              >
                <Checkbox
                  id={index.toString()}
                  checked={reviewTargets.includes(index + 1)}
                  onChange={(e) => {
                    handleChangeReviewTarget(+e.target.id + 1);
                  }}
                />
                <Typography variant="label_M">{`${q.questionId}. ${q.questionTitle}（${q.questionType}）`}</Typography>
              </ListItem>
            ))}
          </List>
        )}
      </Stack>
    </Stack>
  );
}
